import dropdownStyle from '../../../../shared/styles/semantic-ui-dropdown.styled';
import tw, { styled } from 'twin.macro';

export const RowContainer = styled.div`
  ${tw`grid grid-cols-3 p-5`}
  min-height: 65px;
  border: 1px dashed #00a0c6;
  border-radius: 3px;
  gap: 20px;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    padding: 0;
    margin-top: 0;
    gap: 35px;
    border-color: transparent;
    overflow: initial;
    grid-template-columns: var(--grid-template-columns);
  `}

  ${({ isDraggingOver }) =>
    isDraggingOver &&
    `
    background: aliceblue;
    border: 1px solid grey;
  `}

  @media (max-width: 512px) {
    ${tw`flex flex-col`}
  }

  ${({ formWidth }) => formWidth <= 50 && tw`flex flex-col`}
`;

export const ContainerForFieldInRow = styled.div`
  // ${tw`p-5`}

  label {
    word-break: break-word;
  }
`;

export const FieldWrappers = styled.div`
  ${tw`grid grid-cols-2 justify-between gap-2`}
  @media (max-width: 620px) {
    display: block;
  }
  &.allDrpdwnPresent {
    ${tw`grid-cols-3`}
  }
`;

export const DropdownWrapper = styled.div`
  ${tw`p-3.5 w-full`}
  background-color: #F5F5F5;
  & .ui.dropdown {
    ${dropdownStyle};
  }
  @media (max-width: 620px) {
    ${tw`mb-4`}
  }
`;

export const FieldinRow = styled.div`
  ${tw`px-3.5 w-full`}
  @media (max-width: 620px) {
    ${tw`mb-4`}
  }
`;

export const Icons = styled.div`
  display: flex;
`

export const AddField = styled.button`
  ${tw`text-center p-2.5 font-bold `}
  background-color: #F5F5F5;
  grid-column: span2;
  outline: none;
  border: none;
  width: 100%;
`;

export const RowEditWrapper = styled.div`
  ${tw`border border-mainBlue border-dashed rounded p-4`}
`;

export const RowFieldWrapper = styled.div`
  ${tw`ml-2 mr-2`}
  flex-grow: 1;

  ${(props) =>
    props.isDragging &&
    `
    background-color: rgb(250, 250, 250);
    padding: .5rem 1rem;
    box-sizing: content-box;
    left: 0 !important;
    height: fit-content !important;
  `};
`;

export const RowIcons = styled.div`
  display: none;
  @media (max-width: 512px) {
    ${tw`flex flex-row`}
  }
`;

export const IconWrapper = styled.button`
  outline: none;
  border: none;
  background: transparent;
  margin-right: 1rem;
  cursor: pointer;
  & img {
    vertical-align: middle;
  }
`;
